<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <div class="header_dm">
        <p class="little-large-bold_label">メッセージ</p>
        <router-link :to="{name: 'WorkDetail', params: {workId: work.id}}" class="purple-ellipse_button">案件詳細
        </router-link>
      </div>

      <MessageBlock
        :matching-id="matchingId"
        :talker="talker"
        :messages="messages"
        :names="names"
      />

      <router-link :to="{name: 'CreatingBill', params: {matchingId: matching.id}}" class="orange-ellipse_button">
        注文書・請求書
      </router-link>

      <FileBlock :registeredDocumentUrls="work.documentUrls" :workId="work.id"/>

      <ClientMessageButtonBlock v-if="talker === 'client'" :matching="matching" :operator-stripe="operatorStripe"/>
      <OperatorMessageButtonBlock v-if="talker === 'operator'" :matching="matching" :operator-stripe="operatorStripe"/>
    </div>
  </div>
</template>

<script>
  import Meeting from "@/assets/js/pages/matching/meeting/Meeting";
  import {mapGetters} from "vuex";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import sub_collection from "@/assets/js/functions/firebase/firestore/sub_collection";

  import MessageBlock from "@/components/objects/block/message/MessageBlock";
  import FileBlock from "@/components/objects/block/message/FileBlock";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import OperatorMessageButtonBlock from "@/components/objects/block/message/OperatorMessageButtonBlock";
  import ClientMessageButtonBlock from "@/components/objects/block/message/ClientMessageButtonBlock";

  export default {
    name: "Meeting",

    components: {ClientMessageButtonBlock, OperatorMessageButtonBlock, FileBlock, MessageBlock},

    mixins: [Meeting, collection, sub_collection],

    data() {
      return {
        matchingId: '',
        talker: '',
        matching: {},
        messages: [],
        work: {
          id: '',
          documentUrls: [],
        },
        names: {
          operator: '',
          client: '',
        },
        operatorStripe: {},

        hasPushed: false,
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid', customClaim: 'auth/customClaim', office: 'auth/office'}),
    },


    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.matchingId = location.pathname.replace(/^\/matching\/meeting\//, '');
      this.matchingId = this.matchingId.replace(/\/message\/list\/*$/, '');

      await this.getDoc(
        COLLECTION_NAMES.MATCHINGS,
        this.matchingId,
        {}).then(async matching => {
        this.matching = matching;
        this.setTalker(matching);
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      const query = this.subCollectionDocRef(
        COLLECTION_NAMES.MATCHINGS,
        this.matchingId,
        COLLECTION_NAMES.MESSAGES,
      ).where(
        "isDeleted", "==", false
      ).orderBy('createdAt');
      await this.retrieveSubCollectionDocs(query).then(docs => {
        this.messages = docs;
      });

      await this.getDoc('works', this.matching.work.id).then(async readWork => {
        this.work = readWork;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      if (this.talker === 'operator') {
        (this.customClaim.isOwner) ? this.getOperatorStripe(this.uid) : this.getOperatorStripe(this.office.owner.id);
      }

      await this.getDoc(COLLECTION_NAMES.USER_DETAILS, this.matching.operator.id).then(userDetail => {
        this.names.operator = userDetail.lastName + userDetail.firstName;
      });
      await this.getDoc(COLLECTION_NAMES.USER_DETAILS, this.matching.client.id).then(userDetail => {
        this.names.client = userDetail.lastName + userDetail.firstName;
      });
    },

    methods: {
      setTalker(matching) {
        if (matching.client.id === this.uid) {
          this.talker = 'client';
        } else if (matching.operator.id === this.uid) {
          this.talker = 'operator';
        }
      },
      async getOperatorStripe(userId) {
        await this.getDoc(
          COLLECTION_NAMES.OPERATOR_STRIPES,
          userId,
          {}).then(async operatorStripe => {
          this.operatorStripe = operatorStripe ? operatorStripe : {};
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });

      },
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents;

      > .header_dm {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        > .purple-ellipse_button {
          width: 20%;
        }
      }

      > .message_block {
        margin-bottom: 4rem;
        width: 100%;
      }

      > .file_block {
        margin: 4rem 0;
        width: 100%;
      }

      > .orange-ellipse_button, .yellow-ellipse_button, .purple-ellipse_button {
        margin: 1rem 0;
        width: 80%;
      }

      > .little-large-bold_label {
        width: 100%;
      }
    }
  }
</style>